<template>
  <svg
    class="custom-icon"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 6.61933L9.27971 13.8186C9.13978 13.9785 8.88015 13.9785 8.72028 13.8186L2 6.61933C1.78022 6.37962 1.96 6 2.27971 6H6.10294V0.37238C6.10294 0.172526 6.26279 0.0128174 6.4625 0.0128174H11.4974C11.6972 0.0128174 11.8569 0.172672 11.8569 0.37238V6H15.6802C16.0399 6 16.1998 6.37965 16 6.61933ZM18 17.6947V15.6967C18 15.5369 17.8601 15.3971 17.7004 15.3971L0.299637 15.397C0.139782 15.397 0 15.5369 0 15.6966V17.6946C0 17.8544 0.139925 17.9942 0.299637 17.9942H17.7203C17.8802 17.9943 18 17.8745 18 17.6947Z"
    />
  </svg>
</template>
